import * as glb from "../globals";
import query from "devextreme/data/query";

export function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
};

export function myGuid() {
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}
export function myRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
}

export function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export function getHourMinute() {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0'); 
    const minutes = now.getMinutes().toString().padStart(2, '0'); 

    return `${hours}:${minutes}`;
}

export function _(istr) {
    var num = myRandom(0, 3);
    var result = '';
    var ss = '';
    for (let i = 0; i < istr.length; i++) {
        ss = S4();
        ss = ss.substring(0, num) + istr[i] + ss.substring(num + 1, 4);
        result += ss;
    }

    return S4() + num + S4() + '-' + S4() + '-' + S4() + '-' + result;
}

// Converts a Date object to yyyy-MM-ddTHH:mm format for input[type="datetime-local"]
export function formatDateTimeLocal(date) {
    if (!date) return '';
    const d = new Date(date);
    const pad = n => n.toString().padStart(2, '0');
    const yyyy = d.getFullYear();
    const MM = pad(d.getMonth() + 1);
    const dd = pad(d.getDate());
    const HH = pad(d.getHours());
    const mm = pad(d.getMinutes());
    return `${yyyy}-${MM}-${dd}T${HH}:${mm}`;
}

export function hasRight(rghtName) {
    if (glb.default.KULLANICI?.KUL_ISADMIN) return true;

    const rights = Array.isArray(glb.default.HAKLkp) ? glb.default.HAKLkp : [];
    if (!rghtName || rights.length === 0) return false;

    const normalize = (v) =>
        String(v ?? '')
            .trim()
            .toLocaleLowerCase('tr-TR')
            .replace(/\s+/g, '')
            .replace(/_/g, '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');

    const target = normalize(rghtName);
    return rights.some((x) => {
        const values = [
            x?.HAK_ADI,
            x?.HAK_KOD,
            x?.HAK_KODSTR,
            x?.KOD,
            x?.CODE,
        ];
        return values.some((v) => normalize(v) === target);
    });
}

export function hasFieldRight(rghtName) {
    const rights = Array.isArray(glb.default.HAKLkp) ? glb.default.HAKLkp : [];
    if (!rghtName || rights.length === 0) return false;

    const normalize = (v) =>
        String(v ?? '')
            .trim()
            .toLocaleLowerCase('tr-TR')
            .replace(/\s+/g, '')
            .replace(/_/g, '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');

    const target = normalize(rghtName);
    return rights.some((x) => {
        const values = [
            x?.HAK_ADI,
            x?.HAK_KOD,
            x?.HAK_KODSTR,
            x?.KOD,
            x?.CODE,
        ];
        return values.some((v) => normalize(v) === target);
    });
}
